export default __webpack_public_path__ + "static/media/6.42c3a9e8.png";